export default __webpack_public_path__ + "6f7ca422f77f1b9f7ee1d35cebcf19e5.svg";